import React, { useState, useEffect } from "react";
import {withTranslation} from "react-i18next";

const ThemeSwitcher = ({t}) => {
    const [theme, setTheme] = useState(() => {
        const storedTheme = localStorage.getItem("theme");
        if (storedTheme) {
            return storedTheme;
        }
        return window.matchMedia("(prefers-color-scheme: light)").matches
            ? "light"
            : "light";
    });

    useEffect(() => {
        const applyTheme = (theme) => {
            if (theme === "auto" && window.matchMedia("(prefers-color-scheme: dark)").matches) {
                document.documentElement.setAttribute("data-bs-theme", "dark");
            } else {
                document.documentElement.setAttribute("data-bs-theme", theme);
            }
        };

        applyTheme(theme);

        const handleSystemThemeChange = () => {
            if (!["light", "dark"].includes(localStorage.getItem("theme"))) {
                setTheme(window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
            }
        };

        window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", handleSystemThemeChange);

        return () => {
            window.matchMedia("(prefers-color-scheme: dark)").removeEventListener("change", handleSystemThemeChange);
        };
    }, [theme]);

    const handleThemeChange = (newTheme) => {
        localStorage.setItem("theme", newTheme);
        setTheme(newTheme);
    };

    return (
        <ul className="dropdown-menu min-w-auto dropdown-menu-end" aria-labelledby="bd-theme">
            <li className="mb-1">
                <button
                    type="button"
                    className={`dropdown-item d-flex align-items-center ${theme === "light" ? "active" : ""}`}
                    onClick={() => handleThemeChange("light")}
                >
                    <svg
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-brightness-high-fill fa-fw mode-switch me-1"
                        viewBox="0 0 16 16"
                    >
                        <path d="M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z" />
                    </svg>
                    Light
                </button>
            </li>
            <li className="mb-1">
                <button
                    type="button"
                    className={`dropdown-item d-flex align-items-center ${theme === "dark" ? "active" : ""}`}
                    onClick={() => handleThemeChange("dark")}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-moon-stars-fill fa-fw mode-switch me-1"
                        viewBox="0 0 16 16"
                    >
                        <path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z" />
                    </svg>
                    Dark
                </button>
            </li>
            <li>
                <button
                    type="button"
                    className={`dropdown-item d-flex align-items-center ${theme === "auto" ? "active" : ""}`}
                    onClick={() => handleThemeChange("auto")}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-circle-half fa-fw mode-switch me-1"
                        viewBox="0 0 16 16"
                    >
                        <path d="M8 15A7 7 0 1 0 8 1v14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z" />
                    </svg>
                    Auto
                </button>
            </li>
        </ul>
    );
};

export default withTranslation()(ThemeSwitcher)
